export default __webpack_public_path__ + "static/media/st4.1c24f784.jpeg";